import React, { useContext, useState } from 'react'
import { Row, Col } from "react-bootstrap"
import MessageLastEventsBox from '../../components/Products/sBook/MessageLastEventsBox/index.js';
import '../../styles/css/Card.css';
import HomeFilters from '../../components/Products/sBook/HomeFilters/index.js';
import HomeStadistic from '../../components/Products/sBook/HomeStadistic/index.js';
import { useSelector } from "react-redux";
import HomeBookListBox from '../../components/Products/sBook/HomeBookListBox/index.js';
import { useGetHomeStadistic } from '../../hooks/services/sBook/useOfBook.js';
import { useOrderData } from '../../hooks/component/useOfTransversal.js';
import { getGlobalListPageSize } from '../../common/Helpers.js';
import AuthVerify from '../../components/Templates/Site/AuthVerify/index.js';
import MainAppContext from '../../MainAppContext.js';

function Home() {
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);
    const userName = currentAuth !== null ? currentAuth.token.userName.split('\\')[1] : null;


    const [selectedStatusFilter, setSelectedStatusFilter] = useState("1");//null -> Todo. 1 -> Abiertos. 2 -> Cerrados.
    const [forceSearch, setForceSearch] = useState(true);

    const [selectedStartDate, setSelectedStartDate] = useState(null);
    
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [objHomeStadisticData, setObjHomeStadisticData] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: getGlobalListPageSize("homeBookList"), filters: []});
    useGetHomeStadistic(selectedStartDate, selectedEndDate, objHomeStadisticData, setObjHomeStadisticData, selectedStatusFilter, forceSearch, setForceSearch);

    const [selectedStadisticCard, setSelectedStadisticCard] = useState(null);
    const [fireOrderData, setFireOrderData] = useState(false);
    useOrderData(objHomeStadisticData.data, setObjHomeStadisticData, selectedStadisticCard, fireOrderData, setFireOrderData);

    const setterSetSearchData = (value) => {
        setSelectedStatusFilter(value)
        setObjHomeStadisticData({fireUpdate: true, data: null, pageNumber: 1, pageSize: getGlobalListPageSize("homeBookList"), filters: []});
        setForceSearch(true);
    }

    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            <Row>
                <Col xl={12}>
                    <HomeStadistic
                        objStadisticData={objHomeStadisticData}
                        selectedStadisticCard={selectedStadisticCard}
                        setSelectedStadisticCard={setSelectedStadisticCard}
                        setFireOrderData={setFireOrderData}
                        setObjHomeStadisticData={setObjHomeStadisticData} />
                </Col>
            </Row>
            <Row className='pt-2'>
                {
                    //[##CODELCO-CARD-##] Layout book
                    //Layout book
                }
                <Col lg={12} xl={9} className='pe-1'>
                    <HomeBookListBox
                        bookList={objHomeStadisticData}
                        setBookList={setObjHomeStadisticData}
                        securityProps={ contextSite.securityProps }
                        filterStartDate={ selectedStartDate }
                        filterEndDate={ selectedEndDate }
                        userName={ userName }
                        selectedStatusFilter={selectedStatusFilter}
                        setSelectedStatusFilter={setterSetSearchData}
                        forceSearchParent={forceSearch}
                    />
                </Col>
                <Col lg={12} xl={3} className='ps-1'>
                    <MessageLastEventsBox  />
                </Col>
            </Row>
        </>
    );
}

export default Home;